
export const ADMIN_PAGE_ROUTES = {
  HOME: "/admin",
  BOOKINGS: "/admin/bookings",
  BOOKING: "/admin/bookings/:bookingID",
  NEW_BOOKING: "/admin/bookings/new",
  SEARCH: "/admin/search",
  SETTINGS: "/admin/settings",
  SPECIAL_DATES: "/admin/special-dates",
  ACCOUNT: "/admin/account",
};

export const getAdminBookingRoute = (bookingID) => (
  ADMIN_PAGE_ROUTES.BOOKING.replace(":bookingID", bookingID)
);

export const getAdminDayRoute = (date) => (
  `${ADMIN_PAGE_ROUTES.BOOKINGS}?date=${date}`
);

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const LS_ITEM = {
  LOGIN: "ls_1",
};

export const LS_ITEM_ADMIN = {
  SUMMARY_LOAD: "lsa_1",
  DAY_LOAD: "lsa_2",
  LIST_LOAD: "lsa_3",
  BOOKING_LOAD: "lsa_4",
  BOOKING_SAVE: "lsa_5",
  STATUS_SAVE: "lsa_6",
  EXPORT: "lsa_7",
  SETTINGS_LOAD: "lsa_8",
  SETTINGS_SAVE: "lsa_9",
  SPECIAL_LOAD: "lsa_10",
  SPECIAL_SAVE: "lsa_11",
  PASSWORD_SAVE: "lsa_12",
  USERS_LOAD: "lsa_13",
  USER_SAVE: "lsa_14",
};

export const NOTIF_TYPE = {
  STANDARD: 0,
  ERROR: 1,
  SUCCESS: 2,
};

export const BOOKING_STATUS = {
  REQUESTED: "Requested",
  CONFIRMED: "Confirmed",
  SEATED: "Seated",
  CANCELLED: "Cancelled",
  NO_SHOW: "NoShow",
};

export const BOOKING_STATUS_LABELS = {
  Requested: "Request",
  Confirmed: "Confirmed",
  Seated: "Seated",
  Cancelled: "Cancelled",
  NoShow: "No-show",
};
